import React, { useState } from 'react'
import image from './../images/Launch Call to Action Section.png'
import Navbar from '../components/Navbar'
import { ToastContainer } from 'react-toastify'
import { showToast } from '../config/index.handler'
import { supabase } from '../config/supabaseClient'
import { regions } from '../config/CitiesData'

function Waiting() {
    const [firstName,setFirstName] = useState("")
    const [lastName,setLastName] = useState("")
    const [email,setEmail] = useState("")
    const [region, setRegion] = useState("")
    const [ref, setRef] = useState("")
    const [phone, setPhone] = useState("")

    const onJoinPress = async (e) => {
        e.preventDefault()
        if (!firstName || !phone || !ref || !region) {
            showToast("Some fields are required", "error")
            return
        }
        const { data: existingUser } = await supabase.from('waiting').select('id').eq('phone', phone).single();
        if (existingUser) {
            showToast("You are already on the waitlist!", "warning")
            return
        }

        const { error: insertError } = await supabase.from('waiting').insert([
            {
                first_name: firstName, last_name: lastName,
                email, phone, reference: ref, region
            },
        ])

        if (insertError) {
            showToast("Something went wrong. Please try again", "error")
            return
        }

        showToast("Successfully joined the waitlist!", "success")
        
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setRef('')
        setRegion('')
    }

    return (
        <main className="main" id="top">
            <Navbar />
            <section className="position-relative vw-100" style={{height: 400}} id="home">
                <div className="position-absolute w-100 h-100" style={{backgroundImage: `url('${image}')`, backgroundPosition: "top", backgroundSize: "cover", backgroundRepeat: "no-repeat",  top: 0, left: 0, zIndex: -1, filter: "brightness(0.35)"}}>
                </div>
            </section>
            <section className="position-relative p-lg-3 mt-5" style={{ height: 200, zIndex: 999 }} id="form">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-12 col-lg-8">
                            <div className="card p-lg-3" style={{ paddingBottom: 100 }}>
                                <form className="card-body p-lg-5" onSubmit={onJoinPress}>
                                    <div className="mb-4">
                                        <h3 className="mb-0"><b>Waiting Form</b></h3>
                                        <span className="link-primary">
                                            Complete form and submit to join the waiting list
                                        </span>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col">
                                            <div className="form-group mb-3">
                                                <label className="form-label" style={{fontSize: 13}}>First Name</label>
                                                <input type="text" className="form-control" placeholder="Joseph" style={{fontSize: 13}} value={firstName} onChange={(e)=> setFirstName(e.target.value)} required />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-group mb-3">
                                                <label className="form-label" style={{fontSize: 13}}>Last Name</label>
                                                <input type="text" className="form-control" placeholder="Owusu" style={{fontSize: 13}} value={lastName} onChange={(e)=> setLastName(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label" style={{fontSize: 13}}>Where did you hear about us</label>
                                        <select className="form-control" style={{fontSize: 13}} value={ref} onChange={(e)=> setRef(e.target.value)} required>
                                            <option value="">-- Select --</option>
                                            <option value="Friend">Friend</option>
                                            <option value="Social Media">Social Media</option>
                                            <option value="Advertisement">Advertisement</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label" style={{fontSize: 13}}>Region</label>
                                        <select className="form-control" style={{fontSize: 13}} value={region} onChange={(e)=> setRegion(e.target.value)} required>
                                            <option value="">-- Select Region --</option>
                                            {regions.map((item)=> (
                                                <option value={item} key={item}>{item}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label" style={{fontSize: 13}}>Phone</label>
                                        <input type="text" className="form-control" placeholder="0592827932" style={{fontSize: 13}} value={phone} onChange={(e)=> setPhone(e.target.value)} required />
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label" style={{fontSize: 13}}>Email</label>
                                        <input type="email" className="form-control" placeholder="jamestoon@kwik.com" style={{fontSize: 13}} value={email} onChange={(e)=> setEmail(e.target.value)} />
                                    </div>
                                    <button className='btn' type='submit' style={{backgroundColor: '#D1B000', float: 'right', color: '#fff', fontSize: 13}}>Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer position="top-right" autoClose={3000} />
        </main>
    )
}

export default Waiting
